import { Empty } from "antd";
import { ComingSoon, ProhibitedArea, SystemConnections, VerticleMenuContent } from "components";
import AppPaths from "constants/appPaths";
import Tabs from "constants/configurationTabs";
import ApiKeys from "containers/ApiKeys";
import BusinessAreaData from "containers/BusinessAreaData";
import BusinessAreas from "containers/BusinessAreas";
import ChangeDataCaptures from "containers/ChangeDataCaptures";
import DataSyndicationSource from "containers/DataSyndicationSource";
import DataSyndicationSubscription from "containers/DataSyndicationSubscription";
import DataTags from "containers/DataTags";
import Roles from "containers/Roles";
import SystemKeys from "containers/SystemKeys";
import AiModelRouting from "containers/AiModelRouting";
import AiUsage from "containers/AiUsage";
import TenancyCustomization from "containers/TenancyCustomization";
import Users from "containers/Users";
import { Component } from "react";
import { withRouter } from "react-router";

class Configuration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: Object.values(Tabs),
        };
    }

    componentWillMount() {
        this.showBreadCrumbNavigationItems();
    }

    showBreadCrumbNavigationItems = () => {
        if (this.props.setBreadcrumbNavigationItems) {
            let breadcrumbNavigationItems = [
                {
                    route: AppPaths.TENANT_HOME.replace(":tenant", this.props.match.params.tenant.toLowerCase()),
                    text: "Home",
                },
                {
                    route: AppPaths.TENANT_CONFIGURATION.replace(":tenant", this.props.match.params.tenant.toLowerCase()),
                    text: "Configurations",
                },
            ];
            this.setState({
                breadcrumbNavigationItems,
            });
            this.props.setBreadcrumbNavigationItems(breadcrumbNavigationItems);
        }
    };

    showSubBreadCrumbNavigationItems = (subBreadCrumbNavigationItems) => {
        let breadcrumbNavigationItems = [...this.state.breadcrumbNavigationItems, ...subBreadCrumbNavigationItems];
        this.props.setBreadcrumbNavigationItems(breadcrumbNavigationItems);
    };

    getConfigurationItem = (activeItem) => {
        if (activeItem) {
            switch (activeItem.toLowerCase()) {
                case Tabs.TENANCY_CUSTOMIZATION.name:
                    return <TenancyCustomization></TenancyCustomization>;
                case Tabs.USERS.name:
                    return <Users action={this.props.itemAction} userId={this.props.itemId} showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}></Users>;
                case Tabs.ROLES.name:
                    return <Roles action={this.props.itemAction} roleId={this.props.itemId} showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}></Roles>;
                case Tabs.BUSINESS_AREAS.name:
                    return (
                        <BusinessAreas
                            action={this.props.itemAction}
                            businessAreaId={this.props.itemId}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></BusinessAreas>
                    );
                case Tabs.BUSINESS_AREA_DATA.name:
                    return (
                        <BusinessAreaData
                            action={this.props.itemAction}
                            dataDomainId={this.props.itemId}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></BusinessAreaData>
                    );
                case Tabs.DATA_CLASSIFIERS.name:
                    return <DataTags action={this.props.itemAction} tagId={this.props.itemId} showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}></DataTags>;
                case Tabs.API_KEYS.name:
                    return (
                        <ApiKeys
                            action={this.props.itemAction}
                            apiKeyId={this.props.itemId}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></ApiKeys>
                    );
                case Tabs.SYSTEM_CONNECTIONS.name:
                    return (
                        <SystemConnections
                            itemAction={this.props.itemAction}
                            itemId={this.props.itemId}
                            subItem={this.props.subItem}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></SystemConnections>
                    );
                case Tabs.SYSTEM_KEYS.name:
                    return (
                        <SystemKeys action={this.props.itemAction} keyId={this.props.itemId} showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}></SystemKeys>
                    );
                case Tabs.AI_MODEL_ROUTING.name:
                    return (
                        <AiModelRouting action={this.props.itemAction} showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}></AiModelRouting>
                    );
                case Tabs.AI_USAGE.name:
                    return <AiUsage showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}></AiUsage>;
                case Tabs.CHANGE_DATA_CAPTURE.name:
                    return (
                        <ChangeDataCaptures
                            action={this.props.itemAction}
                            destinationId={this.props.itemId}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></ChangeDataCaptures>
                    );
                case Tabs.DATA_SYNDICATION_SOURCE.name:
                    return (
                        <DataSyndicationSource
                            action={this.props.itemAction}
                            sourceId={this.props.itemId}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></DataSyndicationSource>
                    );
                case Tabs.DATA_SYNDICATION_SUBSCRIPTION.name:
                    return (
                        <DataSyndicationSubscription
                            action={this.props.itemAction}
                            subscriptionId={this.props.itemId}
                            showSubBreadCrumbNavigationItems={this.showSubBreadCrumbNavigationItems}
                        ></DataSyndicationSubscription>
                    );
                default:
                    return (
                        <div>
                            <ComingSoon></ComingSoon>
                        </div>
                    );
            }
        }

        return (
            <div className="flex flex-1 items-center justify-center">
                <Empty description="No configuration option selected"></Empty>
            </div>
        );
    };

    onMenuItemClick = (itemName) => {
        this.props.history.push(AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(":configurationItem", itemName.toLowerCase()));
    };

    render() {
        return (
            <>
                {!this.props.activeItem || this.state.items.some((item) => item.name === this.props.activeItem.toLowerCase()) ? (
                    <VerticleMenuContent
                        items={this.state.items}
                        activeItem={this.props.activeItem}
                        itemContainer={this.getConfigurationItem(this.props.activeItem)}
                        onItemClick={this.onMenuItemClick}
                    ></VerticleMenuContent>
                ) : (
                    <ProhibitedArea />
                )}
            </>
        );
    }
}

export default withRouter(Configuration);
